import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { MdClose, MdSearch } from 'react-icons/md';
import { BiCheckCircle } from 'react-icons/bi';
import './ESGAnalyticsConfigPanel.scss';

const ESGAnalyticsConfigPanel = ({ t, configList, onClose, onSelectConfig, loading }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter configurations by search term
  const filteredConfigs = configList.filter(configItem => {
    let configName = '';
    try {
      if (configItem.configData) {
        const configData = JSON.parse(configItem.configData);
        configName = configData.filterName || configData.title || '';
      } else {
        configName = configItem.name || configItem.filterName || '';
      }
    } catch (error) {
      configName = configItem.name || configItem.filterName || '';
    }

    return configName.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const handleConfigClick = (configItem) => {
    if (configItem && configItem.configData) {
      onSelectConfig(configItem);
    }
  };

  return (
    <div className="esg-config-sidebar">
      {/* Header */}
      <div className="esg-config-sidebar__header">
        <div className="esg-config-sidebar__title">
          <h3>{t("ESGAnalytics.selectConfiguration.label") || "Select Configuration"}</h3>
          <p>{configList.length} {t("ESGAnalytics.configurationsAvailable.label") || "configurations available"}</p>
        </div>
        <button
          className="esg-config-sidebar__close-btn"
          onClick={onClose}
        >
          <MdClose />
        </button>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="esg-config-sidebar__loading">
          <div className="loading-spinner"></div>
          <p>{t("ESGAnalytics.loadingConfigurations.label") || "Loading configurations..."}</p>
        </div>
      )}

      {/* Search */}
      {!loading && (
        <div className="esg-config-sidebar__search">
          <div className="esg-config-sidebar__search-input">
            <MdSearch className="esg-config-sidebar__search-icon" />
            <input
              type="text"
              placeholder={t("ESGAnalytics.searchConfigurations.label") || "Search configurations..."}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      )}

      {/* Configurations List */}
      <div className="esg-config-sidebar__content">
        {!loading && filteredConfigs.length === 0 && configList.length > 0 ? (
          <div className="esg-config-sidebar__empty">
            <div className="esg-config-sidebar__empty-icon">🔍</div>
            <h4>{t("ESGAnalytics.noConfigurationsFound.label") || "No configurations found"}</h4>
            <p>{t("ESGAnalytics.adjustSearchTerms.label") || "Try adjusting your search terms"}</p>
          </div>
        ) : !loading && configList.length === 0 ? (
          <div className="esg-config-sidebar__empty">
            <div className="esg-config-sidebar__empty-icon">📋</div>
            <h4>{t("ESGAnalytics.noConfigurationsAvailable.label") || "No configurations available"}</h4>
            <p>{t("ESGAnalytics.createConfigurationFirst.label") || "Create a configuration first"}</p>
          </div>
        ) : !loading ? (
          <div className="esg-config-sidebar__configs-list">
            {filteredConfigs.map((configItem, index) => {
              let configName = '';
              let createdAt = '';
              try {
                if (configItem.configData) {
                  const configData = JSON.parse(configItem.configData);
                  configName = configData.filterName || configData.title || `Configuration ${index + 1}`;
                } else {
                  configName = configItem.name || configItem.filterName || `Configuration ${index + 1}`;
                }
              } catch (error) {
                configName = configItem.name || configItem.filterName || `Configuration ${index + 1}`;
              }

              if (configItem.createdAt) {
                createdAt = new Date(configItem.createdAt).toLocaleDateString();
              }

              return (
                <div
                  key={configItem.id || index}
                  className="esg-config-sidebar__config-item"
                  onClick={() => handleConfigClick(configItem)}
                >
                  <div className="esg-config-sidebar__config-icon">
                    <BiCheckCircle />
                  </div>
                  <div className="esg-config-sidebar__config-info">
                    <h4 className="esg-config-sidebar__config-title">
                      {configName}
                    </h4>
                    {createdAt && (
                      <p className="esg-config-sidebar__config-date">
                        {t("ESGAnalytics.createdOn.label") || "Created on"} {createdAt}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default withTranslation()(ESGAnalyticsConfigPanel);
